// @ts-nocheck


import React, { useEffect } from 'react'
import styles from './JewelryClubs.module.scss'
import GET_JOINED_GROUP from 'src/graphql/queries/sellerQueries/getJoinedGroups'
import { useMutation, useQuery } from '@apollo/client'
import Slider from 'react-slick'
import ClubSlider from 'src/components/StoreAndProductDetailModal/ClubModal/ClubSlider'
import LEAVE_GROUP from 'src/graphql/mutations/leaveGroup'
import JOIN_GROUP from 'src/graphql/mutations/joinGroup'
import { useAuth } from 'src/utils/auth'
import GET_MY_GROUP from 'src/graphql/queries/getGroups'
import GET_GLOBAL_SEARCH_WITH_ELASTIC_SEARCH from 'src/graphql/queries/sellerQueries/getGlobalSearchWithElasticSearch'
import { useSelector } from 'react-redux'
import { fetchMobileModalData } from 'src/store/slices/mobileModalSlice'
import { useAppDispatch } from 'src/store/store'
import { fetchModalData } from 'src/store/slices/manageModalSlice'
import { fetchAllClubSliceData, fetchJoinedClubsData, fetchManageClubsData } from 'src/store/slices/fetchAllClubsSlice'

function SampleNextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <img src="/assets/icon/right-icon-black.svg" alt="RightArrow" />
    </div>
  )
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <img src="/assets/icon/left-icon-black.svg" alt="LeftArrow" />
    </div>
  )
}

export default function JewelryClubs({ title }) {
  const { user }: any = useAuth()
  const fetchSearchModalData = useSelector((state: any) => state?.searchModalSlice?.data)
  const dispatch = useAppDispatch()
  const fetchMobileModal = useSelector((state: any) => state?.manageMobileModal?.data)
  const getAllState = useSelector((state: any) => state?.manageModalData?.data)
  const allManageClub = useSelector((state: any) => state?.clubData?.manageClubs)

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2.8,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 899,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: false,
          centerMode: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1.3,
          initialSlide: 1,
          infinite: false,
          centerMode: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
          infinite: false,
          centerMode: false,
        },
      },
    ],
  }

  useEffect(() => {
    dispatch(fetchManageClubsData({ page: 1, limit: 100, type: 'SUGGESTED_CLUBS' }))
  }, [])

  const [leaveGroup] = useMutation(LEAVE_GROUP, {
    onCompleted: (res) => {
      dispatch(fetchJoinedClubsData({ page: 1, limit: 100, type: 'JOIN_CLUBS' }))
      dispatch(fetchAllClubSliceData({ page: 1, limit: 100, type: 'SUGGESTED_CLUBS', prevPost: [] }))
      dispatch(fetchManageClubsData({ page: 1, limit: 100, type: 'CLUBS_YOU_MANAGE' }))
    },

    onError: (err) => {},
  })

  const [joingroup] = useMutation(JOIN_GROUP, {
    onCompleted: (res) => {
      dispatch(fetchJoinedClubsData({ page: 1, limit: 100, type: 'JOIN_CLUBS' }))
      dispatch(fetchAllClubSliceData({ page: 1, limit: 100, type: 'SUGGESTED_CLUBS', prevPost: [] }))
      dispatch(fetchManageClubsData({ page: 1, limit: 100, type: 'CLUBS_YOU_MANAGE' }))
    },

    onError: (err) => {},
  })

  const leaveGroupCall = (club) => {
    leaveGroup({
      variables: {
        userId: user.id,
        groupId: club?.id,
      },
      update: (proxy, { data }) => {
        const joinedGroup: any = proxy.readQuery({
          query: GET_JOINED_GROUP,
        })
        let updatedData = joinedGroup?.getJoinedGroups?.filter((grp) => grp?.id !== club?.id)
        proxy.writeQuery({
          query: GET_JOINED_GROUP,
          data: { getJoinedGroups: updatedData },
        })

        const suggestedGroup: any = proxy.readQuery({
          query: GET_MY_GROUP,
        })
        proxy.writeQuery({
          query: GET_MY_GROUP,
          data: {
            groups: [
              ...suggestedGroup?.groups,
              {
                ...club,
                isFollow: false,
                members: club?.members?.filter((grp) => grp?.id !== user?.id),
              },
            ],
          },
        })
      },
    })
  }

  const joingroupCall = (club) => {
    joingroup({
      variables: { group_id: club?.id, user_id: user?.id, isAdmin: false },
      update: (proxy, { data }) => {
        const dataInCache: any = proxy.readQuery({
          query: GET_GLOBAL_SEARCH_WITH_ELASTIC_SEARCH,
          variables: {
            search: fetchSearchModalData?.search,
            limit: 10,
            page: 0,
          },
        })
        let updatedData = dataInCache?.globalSearchWithElasticSearch?.data?.groups?.map((grp) => {
          if (club?.id === grp?.id) {
            return {
              ...grp,
              isFollow: true,
              members: [
                {
                  firstName: user?.firstName,
                  lastName: user?.lastName,
                  id: user?.id,
                  profileUrl: user?.logo_image,
                },
                ...grp?.members,
              ],
            }
          } else {
            return grp
          }
        })
        let datass = proxy.writeQuery({
          query: GET_GLOBAL_SEARCH_WITH_ELASTIC_SEARCH,
          data: {
            globalSearchWithElasticSearch: {
              data: { ...dataInCache?.globalSearchWithElasticSearch?.data, groups: updatedData },
            },
          },
        })
      },
    })
  }

  const handleOpenModal = () => {
    dispatch(
      fetchModalData({
        allModalData: [
          ...getAllState?.allModalData,
          { modal: 'jewelryCLubModal', isOpen: true, id: { title }, modalFor: 'bigModal' },
        ],
        lastModalData: getAllState?.lastModalData,
      }),
    )
  }

  return Boolean(allManageClub?.length) ? (
    <>
      <div className={styles.jewelryClubsSection}>
        {/* <div className={styles.jewelryClubsHeading}> */}
        {/* <h6>{title}</h6>
          <div className={styles.webviewMore} onClick={() => handleOpenModal()}> */}
        {/* <Link
            href={{
              pathname: `/jewelry`,
              query: { type: 'club' },
            }}
            scroll={false}
          > */}
        {/* <a>
              See more
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none">
                <path
                  d="M0.977051 1L4.97705 6L0.977051 11"
                  stroke="#556EE6"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a> */}
        {/* </Link> */}
        {/* </div> */}
        {/* ======================================================================MOBILE_VIEW ========================================================== */}
        {/* <div className={styles.mobileviewMore}>
            <a
              onClick={() =>
                dispatch(
                  fetchMobileModalData({
                    allModalData: [
                      ...(fetchMobileModal?.allModalData ? fetchMobileModal?.allModalData : []),
                      {
                        modal: 'mobileJewelryClubModal',
                        isOpen: true,
                        id: 0,
                        transform: 7,
                      },
                    ],
                    lastModalData: fetchMobileModal?.lastModalData,
                  }),
                )
              }
            >
              See more
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none">
                <path
                  d="M0.977051 1L4.97705 6L0.977051 11"
                  stroke="#556EE6"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
        </div> */}

        <div className={styles.jewelryClubflxmain}>
          <div className={styles.JeweleryClubheading}>
            <h1>Popular Accessory Clubs</h1>
            <p>Finding the accessories club for women</p>
          </div>

          {allManageClub?.length > 0 ? (
            <div className={styles.clubModalDetailsAllDetailsAlignment}>
              <Slider {...settings}>
                {allManageClub?.map((club, index) => (
                  <React.Fragment key={index}>
                    <ClubSlider
                      club={club}
                      leaveGroupCall={leaveGroupCall}
                      joingroupCall={joingroupCall}
                      isOpen={true}
                    />
                  </React.Fragment>
                ))}
              </Slider>
            </div>
          ) : (
            <div className={styles.noFollowingStoreDetailsAlignment}>
              {/* <div className={styles.noFollowingImg}>
            {emptyClubSVG}
            <p>You haven’t followed any store</p>
          </div> */}
            </div>
          )}
        </div>
      </div>
    </>
  ) : (
    <></>
  )
}
